module.exports = __webpack_public_path__ + "img/40_69_007_860.799b45fd.jpg";